import { render, staticRenderFns } from "./SummerSale.vue?vue&type=template&id=4df10e67&"
import script from "./SummerSale.vue?vue&type=script&lang=js&"
export * from "./SummerSale.vue?vue&type=script&lang=js&"
import style0 from "./SummerSale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports